import React, { RefObject } from "react";
import * as GQL from "src/types/graphql";

type Mode = "edit" | "view";
export type FormTemplateContextType = {
  menuRef: RefObject<HTMLDivElement>;
  organization: GQL.Organization;
  actionRef: RefObject<HTMLDivElement>;
  mode: Mode;
  formTemplate: GQL.EditFormTemplateFragment;
};

export const FormTemplateContext =
  React.createContext<FormTemplateContextType | null>(null);

export const useFormTemplateContext = () => {
  const context = React.useContext(FormTemplateContext);
  if (!context) {
    throw new Error(
      "useFormTemplateContext must be used within FormTemplateContext.Provider"
    );
  }
  return context;
};
